import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Candidate Portal',
    title: 'Give candidates a world-class experience',
    subtitle: 'A self-service portal where candidates browse jobs, apply with resumes, take assessments, join interviews, and track their application status.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #0076A3 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Self-Service Hiring',
      title: 'Everything candidates need in one place',
      features: [
        { icon: '🔍', title: 'Browse Open Positions', desc: 'Candidates see all active jobs with descriptions, skills, location, and an Apply button — no recruiter handholding needed.' },
        { icon: '📄', title: 'Apply with Resume', desc: 'One-click application with resume upload. AI parses and scores the resume against the JD automatically.' },
        { icon: '📋', title: 'Take Assessments', desc: 'Assessments appear in the candidate portal with a Take Assessment button. Timed, anti-cheated, AI-scored.' },
        { icon: '🎥', title: 'Join Interviews', desc: 'Interview invitations show up with a Join link. In-browser video interview with live transcription.' },
        { icon: '🔔', title: 'Real-Time Notifications', desc: 'Candidates get notified when assessments or interviews are assigned. Notification bell with unread count.' },
        { icon: '📊', title: 'Track Application Status', desc: 'My Applications tab shows every job applied for, with status badges: Applied, Screening, Interview, Offered.' },
      ],
      columns: 3,
    },
    {
      label: 'Recruiter Benefits',
      title: 'Reduce back-and-forth, accelerate your pipeline',
      desc: 'When candidates self-apply, their resumes are automatically parsed, scored, and ranked. Push assessments and interviews with one click from the Applications page.',
      bullets: ['Candidates apply directly — no email chains', 'Resumes auto-scored and ranked in your pipeline', 'Push assessments and interviews to any candidate', 'Self-applied candidates tagged with green badge', 'Unified Applications view across all jobs'],
      visual: '🚀',
      visualLabel: 'Automated Candidate Pipeline',
    },
  ],
  testimonial: { quote: 'Candidates love the self-service portal. Our application-to-assessment completion rate went from 40% to 85% after switching to CHIRE.', name: 'Priya D.', role: 'Founder, StartupLab' },
  cta: { title: 'Elevate your candidate experience', desc: 'Let candidates apply, assess, and interview on their own schedule. You focus on hiring the best.' },
};

export default function EngagePage() { return <ProductPageTemplate data={DATA} />; }
